import React, { Component } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ModalB from 'components/Modal/ModalB';
import ImageA from 'components/Image/ImageA';
import classes from './PackageTabB.module.scss';

class PackageTabBAttribute extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showPopup: false,
    };

    this.togglePopup = this.togglePopup.bind(this);
  }

  togglePopup() {
    const { showPopup } = this.state;
    this.setState({ showPopup: !showPopup });
  }

  render() {
    const {
      title,
      displayText,
      description,
      image = [],
    } = this.props;

    function renderDisplayName(instance) {
      if (displayText) {
        if (description) {
          return ([
            <button
              key={`${title}-button`}
              onClick={instance.togglePopup}
              className={classNames(classes.attributeLink, classes.gridCellDetailsTitle)}
              dangerouslySetInnerHTML={{ __html: displayText }}
              aria-label={displayText}
              type='button'
            />,
            typeof window !== 'undefined'
              ? (
                <Modal
                  key={`${title}-modal`}
                  isOpen={instance.state.showPopup}
                  onRequestClose={instance.togglePopup}
                  shouldCloseOnOverlayClick
                  ariaHideApp={false}
                  className={classes.modal}
                  overlayClassName={classes.overlayModal}
                  closeTimeoutMS={250}
                >
                  <ModalB hideModal={instance.togglePopup}>
                    <div className={classes.modalWrapper}>
                      <ImageA
                        width={95}
                        height={95}
                        className={classes.packageAttributeImageWrapper}
                        {...image}
                      />
                      <div
                        className={classes.attributeDescription}
                        dangerouslySetInnerHTML={{ __html: description }}
                      />
                    </div>
                  </ModalB>
                </Modal>)
              : (
                <div>
                  <ImageA
                    width={95}
                    height={95}
                    className={classes.packageAttributeImageWrapper}
                    {...image}
                  />
                  <div
                    className={classes.attributeDescription}
                    dangerouslySetInnerHTML={{ __html: description }}
                  />
                </div>),
          ]);
        }
        return (
          <div
            className={classes.gridCellDetailsTitle}
            dangerouslySetInnerHTML={{ __html: displayText }}
          />
        );
      }

      return null;
    }

    return (
      renderDisplayName(this)
    );
  }
}

PackageTabBAttribute.propTypes = {
  title: PropTypes.string,
  displayText: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.object,
};

export default PackageTabBAttribute;
